import React from 'react';
import { Table, Tag, Typography, Modal, Toast } from '@douyinfe/semi-ui';
import { renderTimestamp, stringToColor } from '../../helpers/render';

const { Text, Paragraph } = Typography;

const LogsList = ({ logs, loading, pageSize, setPageSize }) => {

    const copyText = async (text) => {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            Toast.success('已复制：' + text);
        } else {
            Modal.info({ title: '复制内容', content: text });
        }
    };

    const columns = [
        {
            title: '时间',
            dataIndex: 'created_at',
            render: (text) => (
                <span style={{ fontFamily: 'var(--code-font, monospace)', color: 'var(--apple-text-secondary)' }}>
                    {renderTimestamp(text)}
                </span>
            ),
        },
        {
            title: '模型',
            dataIndex: 'model_name',
            render: (text) => (
                <Tag
                    color={stringToColor(text)}
                    onClick={() => copyText(text)}
                    style={{
                        cursor: 'pointer',
                        borderRadius: 6,
                        fontWeight: 600,
                        border: 'none',
                        padding: '4px 8px'
                    }}
                >
                    {text}
                </Tag>
            ),
        },
        {
            title: 'IP',
            dataIndex: 'ip',
            render: (text) => (
                <Tag style={{
                    background: 'rgba(52, 199, 89, 0.1)',
                    color: 'var(--apple-green)',
                    border: 'none',
                    borderRadius: 6,
                    fontWeight: 600
                }}>
                    {text || '未知'}
                </Tag>
            )
        },
        {
            title: '用时',
            dataIndex: 'use_time',
            render: (text) => (
                <Tag style={{ background: 'rgba(0,0,0,0.04)', color: '#666', border: 'none', borderRadius: 6 }}>
                    {text}s
                </Tag>
            )
        },
        {
            title: '提示',
            dataIndex: 'prompt_tokens',
            render: (text, record) => {
                if (record.model_name.startsWith('mj_')) return null;
                return (record.type === 0 || record.type === 2) ?
                    <span style={{ fontFamily: 'var(--code-font, monospace)' }}>{text}</span> : null;
            },
            sorter: (a, b) => (a.prompt_tokens || 0) - (b.prompt_tokens || 0)
        },
        {
            title: '补全',
            dataIndex: 'completion_tokens',
            render: (text, record) => {
                if (parseInt(text) > 0 && (record.type === 0 || record.type === 2)) {
                    return <span style={{ fontFamily: 'var(--code-font, monospace)' }}>{text}</span>;
                }
                return null;
            },
            sorter: (a, b) => (a.completion_tokens || 0) - (b.completion_tokens || 0)
        },
        {
            title: '花费',
            dataIndex: 'quota',
            render: (text) => {
                // 如果 quota 已经是美元格式（小于1000），直接显示；否则需要转换
                const usdValue = text < 1000 ? text : text / 500000;
                return (
                    <span style={{ fontWeight: 600, color: 'var(--apple-text-primary)' }}>
                        ${usdValue.toFixed(6)}
                    </span>
                );
            }
        },
        {
            title: '详情',
            dataIndex: 'content',
            render: (text, record) => {
                if (record.type !== 0 && record.type !== 2) {
                    return <></>;
                }
                // 处理详情文本 - 只保留"模型倍率"或"模型价格"开始的内容
                let displayText = text || '';
                const match = displayText.match(/(模型倍率|模型价格).*/);
                displayText = match ? match[0] : displayText;
                // 倍率如果是整数就不显示小数点，例如 7.00 -> 7
                displayText = displayText.replace(/(\d+)\.00/g, '$1');

                return (
                    <Paragraph
                        ellipsis={{
                            rows: 2,
                            showTooltip: {
                                type: 'popover',
                            },
                        }}
                    >
                        {displayText}
                    </Paragraph>
                );
            }
        }
    ];

    return (
        <div className="apple-card" style={{ marginTop: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0 }}>调用日志</h3>
            </div>
            <Table
                columns={columns}
                dataSource={logs}
                loading={loading}
                pagination={{
                    pageSize: pageSize,
                    onPageSizeChange: setPageSize,
                    showSizeChanger: true,
                    showTotal: (total) => `共 ${total} 条`
                }}
                className="glass-table"
            />
        </div>
    );
};

export default LogsList;

